export default "__VITE_ASSET__5bb5983a__"